import * as React from 'react';

const LilTriangle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="19"
    fill="none"
    viewBox="0 0 13 19"
    {...props}
  >
    <path
      fill="var(--yellow)"
      d="M11.379 7.379 5.172 1.172A4 4 0 0 0 2.343 0H1a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h1.343a4 4 0 0 0 2.829-1.172l6.207-6.207a3 3 0 0 0 0-4.242"
    ></path>
  </svg>
);

export default LilTriangle;
